module.exports = __webpack_public_path__ + "static/images/event/Flag-Left-Pink.png";